import {useDispatch, useSelector} from 'react-redux'
import {AppStore} from '../redux/store'
import {logoutUser, setApplicationId} from '../redux/states/user'
import {useEffect, useState} from 'react'

export const useAuth = () => {
  const APPLICATIONS = {
    Central: {
      path: '/central',
      img: '/media/svg/panel-logos/01-CENTRAL.svg',
      description: 'Central',
      label: 'Khipu Central',
    },
    Hotelería: {
      path: '/hoteleria',
      img: '/media/svg/panel-logos/02-HOTELERIA.svg',
      description: 'Hotelería',
      label: 'Khipu Hoteleria',
    },
    Comedores: {
      path: '/control-comensales',
      img: '/media/svg/panel-logos/03-COMENSALES.svg',
      description: 'Control de Comensales',
      label: 'Khipu Control de Comensales',
    },
    Lavandería: {
      path: '/lavanderia',
      img: '/media/svg/panel-logos/04-LAVANDERIA.svg',
      description: 'Lavanderia',
      label: 'Khipu Lavanderia',
    },
    Recreación: {
      path: '/recreacion',
      img: '/media/patterns/HOTELERIA.svg',
      description: 'Recreación',
      label: 'Khipu Recreación',
    },
    Custodia: {
      path: '/custodia',
      img: '/media/patterns/HOTELERIA.svg',
      description: 'Custodia',
      label: 'Khipu Custodia',
    },
    Hospitality: {
      path: '/hospitality',
      img: '/media/svg/panel-logos/04-LAVANDERIA.svg',
      description: 'Hospitality',
      label: 'Khipu Hospitality',
    },
  } as any

  const userState = useSelector((store: AppStore) => store.user)
  const [applications, setApplications] = useState<any>([])
  const dispatch = useDispatch()

  const getApplicationsUser = () => {
    const mappedApps = userState.lstAplicaciones
      .map((app) => {
        const exist = APPLICATIONS[app.nombre]
        const obj = {...exist, aplicacionId: app.aplicacionId}
        return obj
      })
      .filter((item) => !!item)
    setApplications(mappedApps)
  }

  useEffect(() => {
    getApplicationsUser()
  }, [])

  const logout = () => {
    dispatch(logoutUser())
    localStorage.removeItem('persist:root')
    dispatch(setApplicationId(''))
  }

  const handleApplicationId = (id: string) => {
    dispatch(setApplicationId(id))
  }

  return {
    user: userState,
    logout,
    applications,
    handleApplicationId,
  }
}
